var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 600,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        okText: "保存",
        cancelText: "取消",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "单据编号",
                    labelCol: { span: 5 },
                    wrapperCol: { span: 18 },
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["number"],
                        expression: "['number']",
                      },
                    ],
                    attrs: { readOnly: true },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "备注",
                    labelCol: { span: 5 },
                    wrapperCol: { span: 18 },
                  },
                },
                [
                  _c("a-textarea", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["remark"],
                        expression: "['remark']",
                      },
                    ],
                    attrs: { rows: 4, placeholder: "请输入备注" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }